import { render, staticRenderFns } from "./follow-up-records.vue?vue&type=template&id=0884ac05&scoped=true"
import script from "./follow-up-records.vue?vue&type=script&lang=js"
export * from "./follow-up-records.vue?vue&type=script&lang=js"
import style0 from "./follow-up-records.vue?vue&type=style&index=0&id=0884ac05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884ac05",
  null
  
)

export default component.exports